var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplicatedGradientPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 444,
    viewBox: "0 0 530 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_885_21445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-255.979 -262.618L-255.979 320.446L477.956 320.446L477.956 -262.618L-255.979 -262.618Z",
    fill: "#DF39EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-282.935 232.958L-282.935 724.338L636.602 724.338L636.602 232.958L-282.935 232.958Z",
    fill: "#A180FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.195 7.64294L-111.195 724.938L552.658 724.937L552.658 7.64285L-111.195 7.64294Z",
    fill: "#1C102F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_885_21445",
    x: -532.935,
    y: -512.618,
    width: 1419.54,
    height: 1487.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_885_21445"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplicatedGradientPink);
export default __webpack_public_path__ + "static/media/ComplicatedGradientPink.49d0c5512198835064363da687031a2b.svg";
export { ForwardRef as ReactComponent };